module.exports = {
    apiUrl: process.env.REACT_APP_API_URL,
    glsShipperId: process.env.GLS_SHIPPER_ID,
    glsApiUrl: process.env.GLS_API_URL,
    glsApiUser: process.env.GLS_API_USER,
    glsApiPassword: process.env.GLS_API_PASSWORD,
}